import { types } from 'mobx-state-tree';

const ProductAdditionalTab = types.model({
  title: types.string,
  text: types.string
});

export default ProductAdditionalTab;



// WEBPACK FOOTER //
// ./src/models/ProductAdditionalTab.js